import { render, staticRenderFns } from "./SidebarShell.vue?vue&type=template&id=3e302ea2&scoped=true&"
var script = {}
import style0 from "./SidebarShell.vue?vue&type=style&index=0&id=3e302ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e302ea2",
  null
  
)

export default component.exports